<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Left column',
              modelPath: [this, 'form', 'left_column'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Right column',
              modelPath: [this, 'form', 'right_column'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
